import Filter from "sap/ui/model/Filter";
import FilterOperator from "sap/ui/model/FilterOperator";

/**
 * User Filter Service - Handles filtering logic for user tables and lists
 */
export class UserFilterService {
	createUserFilter(searchValue: string): Filter {
		if (!searchValue || searchValue.trim() === "") {
			return new Filter({
				filters: [],
				and: false,
			});
		}

		return new Filter({
			filters: [
				new Filter("username", FilterOperator.Contains, searchValue),
				new Filter("email", FilterOperator.Contains, searchValue),
				new Filter("cardCode", FilterOperator.Contains, searchValue),
				new Filter("role", FilterOperator.Contains, searchValue),
			],
			and: false,
		});
	}
}
